export default __webpack_public_path__ + "static/media/IMG_20181027_193119_899.a9e0a9c6.jpg";